import * as countryCodes from "country-codes-list";
import {CountryData} from "country-codes-list";

/**
 * This is a utility interface to represent a phone number
 */
export interface PhoneNumberEntry {
  countryCode: string;
  number: string;
}

/**
 * This is an interface to represent the fields we need to populate a country dial code drop down
 */
export interface CountryCode {
  code: string;
  countryISOCode: string;
  countryName: string;
}

/**
 * We store this list so we don't have to recompute it all the time
 */
const countryCodesList: CountryCode[] = [];

/**
 * This function is used to lazily load the country dial code list
 */
export function loadPhoneNumberCountryCodes(): CountryCode[] {
  // Return list if already computed
  if (countryCodesList.length > 0) {
    return countryCodesList;
  }

  const countryData = countryCodes.all();
  countryData.forEach((c: CountryData) => {
    countryCodesList.push(
        {
          code: `+${c.countryCallingCode}`,
          countryISOCode: c.countryCode.toLowerCase(),
          countryName: c.countryNameEn
        })
  })
  return countryCodesList;
}